import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OrgService } from '../../Services/org.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Global } from '../../Shared/global';
import { AppContext } from '../../Shared/common';

@Component({
  selector: 'app-org-input',
  templateUrl: './org-input.component.html',
  styleUrls: ['./org-input.component.css']
})
export class OrgInputComponent implements OnInit {
  orgForm: FormGroup;
  isLoading = false;
  errorMessage = '';
  successMessage = '';

  constructor(
    private orgService: OrgService,
    private router: Router,
    private formBuilder: FormBuilder,
    private appctx: AppContext
  ) {
    this.orgForm = this.formBuilder.group({
      orgSlug: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.pattern(/^[a-zA-Z0-9-]+$/)
      ]]
    });
  }

  ngOnInit(): void {
    // Org selection should only be done by AppInitializer, not here
    Global.Log('[OrgInputComponent] Initialized');
  }

  /**
   * Handle organization submission
   */
  onSubmitOrg(): void {
    if (this.orgForm.invalid) {
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';
    this.successMessage = '';

    const orgSlug = this.orgForm.value.orgSlug.trim().toLowerCase();

    // Validate organization slug with backend
    this.orgService.validateOrgSlug(orgSlug).subscribe({
      next: (response) => {
        this.isLoading = false;
        if (response) {
          debugger
          // Store organization and redirect
          this.orgService.storeOrgSlug(response.OrgName);
          this.orgService.setCurrentOrganization(response);
          this.successMessage = `"${response.OrgName}" selected successfully!`;
          
          setTimeout(() => {
            // Redirect to org-scoped domain
            const url = this.orgService.redirectToOrgDomain(response.OrgName);
            window.location.href = url;
            //this.router.navigate(['/login']);
          }, 1000);
        } else {
          debugger;
          this.errorMessage = 'Centre not found. Please check and try again.';
        }
      },
      error: (error) => {
        this.isLoading = false;
        this.errorMessage = error.error?.message || 'Error validating centre. Please try again.';
      }
    });
  }

  /**
   * Get form control for template
   */
  get orgSlug() {
    return this.orgForm.get('orgSlug');
  }
}
